/* eslint-disable no-debugger */
/* eslint-disable import/no-useless-path-segments */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
/* eslint-disable prefer-arrow-callback */

import React, { useEffect, useState, useReducer } from 'react'
import { connect, useDispatch } from 'react-redux'
import FileBase64 from 'react-file-base64';
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";

import PropTypes, { object } from 'prop-types';
import clsx from 'clsx'
import moment from 'moment';
// import {  } from "@material-ui/core";
import { Modal, Dialog, DialogTitle, DialogContent, DialogActions, Box, TextField, Grid, FormGroup, IconButton, Button as MuiButton } from '@material-ui/core'; // Remove the unused imports for CHG0073013
import { useHistory, useParams, Link } from 'react-router-dom';
import InputAdornment from '@material-ui/core/InputAdornment';
import { SearchOutlined } from '@material-ui/icons';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ClearIcon from '@mui/icons-material/Clear';
import Radio from '@mui/material/Radio';
import Checkbox from '@mui/material/Checkbox';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { MdReplay } from 'react-icons/md';
import styles from './BookingStatus.module.css'
import { CustomNameTab, CustomDatePicker, CustomFormGroup, CustomSelect, ValidatingTextField } from '../FormComponents'
import { DATE_FORMAT, API_RESOURCE_URLS, DISPLAY_MESSAGES, MESSAGE_TYPE, RESOURCE_TYPE, USER_OPERATIONS, Regex } from '../../constants'
import { API } from '../../apis/api'
import TextIcon from './TextIcon'
import { buildErrorMessage } from '../../apis/calls'
import Table from '../Table/Table';
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import { AuthChecker, Button } from '../../atomicComponents';
import { withAllowedOperationsProvider } from '../../hocs'
import Truckloading from "../../components/CvLoader/Cvloader";

import { setToast, setPORow, poSearch, fetchChassis, setChassisData, setAllDetails, getInvoice } from '../../redux/actions/productsActions';
import TableSimple from '../../atomicComponents/TableSimple1/TableSimple';
import { setLogin } from '../../redux/features/auth/actions';
import useDebounceSearch from '../../hooks/useDebounceSearch';
import { sanitizeNumeric } from '../../utils/utils';
import apiService from '../../apis/apiService';

const initialState = {
  ticket_number: "",
  employeDetails: {},
  userRemark: "",
  bcHeadRemark: "",
  superAdminRemark: "",
  chassisNo: null,
  toDate: null,
  fromDate: null,
  bodyBuilder: null,
  checkFlag: false,
  checkBox: true

}
const reducer = (state, action) => {
  switch (action.type) {
    case 'update':
      return {
        ...state,
        [action.field]: action.value
      }
    case 'reset':
      return {
        ...state,
        ...initialState
      }
    default:
      return state
  }
}

function AccessControlForm({ redirectToProcessPage, product, counter, baseUrl, auth }) {
  // const auth = useSelector((state) => state.auth); // useSelector
  let { userRole, userID, personNumber, companyCode, persArea, apiSendData } = auth; // get user pers_no and manager details 
  // userRole = 'B'
  // userRole = 'SA'
  // persNo = "252899"
  // console.log(auth)
  const { requestType, activeId } = useParams();
  const ROW_HEIGHT = 38;
  const [rowsData, setRowsData] = useState({
    loading: false,
    data: [],
    filteredData: [],
  });
  const [poData, setPOData] = useState({
    loading: false,
    data: [],
    filteredData: [],
    last: false,
    number: 0
  });
  const [approveFlag, setApproveFlag] = useState("")
  const [state, dispatch] = useReducer(reducer, initialState);
  const { showInternalError } = usePopupManager();
  const { showPopup } = usePopupManager();
  const [ticketEvent, setTicketEvent] = useState('')
  const [loading, setLoading] = React.useState(false);

  const dispatchNew = useDispatch();
  const history = useHistory();

  const { damage, invoice, plant, part, aqCommodity, purchaseCommodity, supplierCode, supplierDetails, supplierName,
    supplierLocation, selectedProject, selectedPO, inputFields, errors } = state;


  const [suppliers, getSuppliers] = useState({ loading: false, data: [] });
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [confirmModalFlag, setConfirmModal] = useState(false);
  const [confirmModalFlag2, setConfirmModal2] = useState(false);
  const [deleteParam, handleDeleteParam] = useState();
  const [deleteParam2, handleDeleteParam2] = useState();
  const [resetAllVisitedFields, setResetAllVisitedFields] = useState(false);
  const [highlightMandatoryFields, setHighlightMandatoryFields] = useState(false);
  const [viewDisplay, setViewDisplay] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [userRemark, setUserRemark] = useState("");
  const [bStatus, setBStatus] = useState("");
  const [eDetails, setEDetails] = useState("");

  const [toggle, setToggle] = React.useState(false);
  const [loader, setLoader] = React.useState(true);
  const [hover, setHover] = useState({ isHover: false, name: null });

  const [chassisOption, setChassisData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [asnCount, setAsnCount] = useState(0);
  const [mobile, setMobile] = useState(window.innerWidth <= 500)

  const [companyCodeOption, setCompanyCode] = useState([]);
  const [disableButtton, setDisableButtton] = useState(false)
  const [apiPayloadData, setAPIPaylodData] = useState(apiSendData);

  const handleWindowSizeChange = () => {
    setMobile(window.innerWidth <= 500);
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  // console.log(mobile,"mobile 169")

  useEffect(() => {
    window.addEventListener('popstate', function (event) {
      history.push("/requestor-dashboard")
    });
  }, []);

  const [myState, setState] = React.useState(
    {
      ticket_number: "",
      employeDetails: {},
      userRemark: "",
      bcHeadRemark: "",
      superAdminRemark: "",
      chassisNo: null,
      toDate: null,
      fromDate: null,
      startDate: null,
      endDate: null,
      bodyBuilder: null,
      checkFlag: false,
      checkBox: true

    });
  const handleIDChange = (e) => {
    // console.log(e)
    // console.log(e.target.value)
    setTicketNumber(e.target.value);
  }
  const isValidInput = (input) => {
    const validCharacters = /^[a-zA-Z0-9.,/&?' -]+$/;
    return validCharacters.test(input);
  };
  const [ticketNumber, setTicketNumber] = useState("");
  const searchByTicket = useDebounceSearch(ticketEvent)
  const [employeeDetails, setEmployeeDetails] = useState([{
    ticket_no: (<ValidatingTextField
      variant="outlined"
      size="small"
      value={ticketNumber}
      onChange={(e) => handleIDChange(e)}
      name="manager_id"
      inputProps={{
        "data-testid": "remark-input",
      }}
      style={{ width: "60%" }}
    />),
    empName: "",
    bcNumber: "",
    bcName: "",
    workArea: "",

  }])

  const hasSARole = userRole.includes("SA");
  const [disableTicketNumber, setDisableTicketNumber] = useState(false);

  useEffect(() => {
    const getRequestDetails = async() => {
      setLoading(true)
      let apiFormatedData = {
        "request_id": activeId
      }
      var apiFormatedDataJson = JSON.stringify(apiFormatedData);   
      let headerss = new Headers();
      headerss.append('Content-Type', 'application/json');
      try {
        const response = await apiService.AccessControlRequestDets(apiFormatedData, dispatchNew)
        dispatchNew(setLogin({ ...auth, recentStatus: response.status }))
        if (response?.["msg"] === "Success") {
          setLoading(false)
          setState((prevData) => ({
            ...prevData, ticket_number: response.data[0]["pers_no"],
            employeDetails: response.data[0],
            userRemark: response.data[0]["user_remark"],
            startDate: response.data[0]["effective_date"],
            endDate: response.data[0]["end_date"],
            bcHeadRemark: response.data[0]["bc_remark"],
            bcApprove: response.data[0]["bc_approval_status"],
            superAdminRemark: response.data[0]["admin_remark"],
            saApprove: response.data[0]["admin_approval_status"],

          }));
          setEDetails(response.data[0]["pers_no"].length)
        }
        else if (response?.["msg"] === "Fail") {
          setLoading(false)
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: response?.msg,
          });
        }
      } catch (error) {
        setLoading(false)
          console.info(error)
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "Oops! Something went wrong. Please try again later",

          });
      } finally{
        setLoading(false)
      }   
    }
    if (activeId) {
      getRequestDetails()
    }
  }, [activeId]);

  const handleUserRequest = async() => {
    setLoading(true)
    let apiFormatedData =
    {
      "pers_no": sanitizeNumeric(myState.ticket_number),
      "bc_person_no": myState.employeDetails["bc_pers_no"],
      "request_flag": "BS",
      "created_by": personNumber,
      "request_type": myState.employeDetails["employee_bookable_status"] && myState.employeDetails.employee_bookable_status === "Y" ? "BS-UBK" : "BS-BK",
      "user_remark": myState.userRemark,
      "start_date": myState.startDate,
      "end_date": myState.endDate,
      "user_role": userRole
    }
    // console.log(apiFormatedData);
    var apiFormatedDataJson = JSON.stringify(apiFormatedData);
    let headerss = new Headers();
    headerss.append('Content-Type', 'application/json');
    try {
      const response = await apiService.AccessControlnewRequest(apiFormatedData, dispatchNew)
      dispatchNew(setLogin({ ...auth, recentStatus: response.status }))
      if (response?.msg === "Success") {
        setLoading(false)
        const apiPayloadData = {
          user_id: personNumber,
          req_type: "created",
          request_status: null,
          start_date: "",
          end_date: "",
        };

        dispatchNew(setLogin({ ...auth, apiSendData: apiPayloadData }))

        if (response['data'] != 'Request for Change of Booking Status is already in progress') {
          setState(initialState)
          setEDetails(0)
          showPopup({
            type: MESSAGE_TYPE.SUCCESS,
            contextText: MESSAGE_TYPE.SUCCESS,
            info: `Booking status request ${response["request_id"]} generated successfully.`,
          });
          history.push("/requestor-dashboard");
        } else if (response['data'] === 'Request for Change of Booking Status is already in progress') {
          showPopup({
            type: MESSAGE_TYPE.SUCCESS,
            contextText: MESSAGE_TYPE.SUCCESS,
            info: `Request for Change of Booking Status is already in progress`
          });
        }
        else {
          showPopup({
            type: MESSAGE_TYPE.SUCCESS,
            contextText: MESSAGE_TYPE.SUCCESS,
            info: response?.data
          });
        }
      }
      else if (response?.msg === "Fail") {
        setLoading(false)
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: response?.data,
        });
      }
    } catch (error) {
      setLoading(false)
      console.info(error)
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Oops! Something went wrong. Please try again later",

      });
    }
  }

  const handleApproveReject = async(type, flag) => {
    setLoading(true)
    let apiFormatedData = {}
    if (type === "BCHead") {
      apiFormatedData =
      {
        "user_role": type,
        "request_id": activeId,
        "created_by": personNumber,
        "start_date": myState.startDate,
        "end_date": myState.endDate,
        "bc_head_remark": myState.bcHeadRemark,
        "approval_flag": flag
      }
    } else if (type === "SuperAdmin") {
      apiFormatedData =
      {
        "user_role": type,
        "request_id": activeId,
        "created_by": personNumber,
        "start_date": myState.startDate,
        "end_date": myState.endDate,
        "admin_remark": myState.superAdminRemark,
        "approval_flag": flag
      }
    }
    // console.log(apiFormatedData);
    var apiFormatedDataJson = JSON.stringify(apiFormatedData);
    // console.log("final", apiFormatedDataJson);
    let headerss = new Headers();
    headerss.append('Content-Type', 'application/json');
    try {
      const response = await apiService.BookingStatusApprove(apiFormatedData, dispatchNew)
      dispatchNew(setLogin({ ...auth, recentStatus: response.status }))
       // console.log(responseJson);
       if (response?.data?.length) {
        if (response?.msg === "Success") {
          setLoading(false)
          let msg = ""
          if (flag === "A") {
            msg = `Request approved for : ${activeId}.`
          } else if (flag === "R") {
            msg = `Request rejected for : ${activeId}.`
          }
          showPopup({
            type: MESSAGE_TYPE.SUCCESS,
            contextText: MESSAGE_TYPE.SUCCESS,
            info: msg,
          });
          setApproveFlag(flag)

        }
        else if (response?.msg === "Fail") {
          setLoading(false)
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: response?.data,
          });
        }
        setState(initialState)
        setEDetails(0)
        setTimeout(() => {
          history.push("/requestor-dashboard");
        }, 1000); // Delay of 1 seconds
      };
      setTimeout(() => {
        history.push("/requestor-dashboard");
      }, 1000)
    } catch (error) {
      setLoading(false)
      console.info(error)
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Oops! Something went wrong. Please try again later",

      });
    }
  }

  function getDateOnly(date) {
    if (date instanceof Date) {
      // Native Date handling
      const year = date.getFullYear();
      let month = (date.getMonth() + 1).toString().padStart(2, '0');
      let day = date.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    } else if (date && typeof date.format === 'function') {
      // Moment.js handling
      return date.startOf('day').format('YYYY-MM-DD');
      // return date.format('YYYY-MM-DD');
    } else {
      throw new Error('Invalid date passed to getDateOnly');
    }
  }
  const dateValidation = (date, name, request_type, call_from = null) => {
    if (request_type == "BS-UBK") {
      if (name === "startDate") {
        let startDate = getDateOnly(date)
        let endDate = null;
        if (myState.endDate === undefined || myState.endDate === null || call_from === 'api') {
          endDate = startDate
        } else {
          endDate = new Date(myState.endDate);
        }
        if (new Date(startDate) > endDate) {
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "Start date should not be greater than end date",
          });
        } else {
          startDate = new Date(startDate).toISOString().split('T')[0];
          endDate = new Date(endDate).toISOString().split('T')[0];
          setState((prevData) => ({ ...prevData, [name]: startDate, endDate: endDate }));
        }
      } else if (name === "endDate") {
        // let endDate = new Date(new Date().toISOString().split('T')[0]); // Removes the time part from today's date
        let endDate = getDateOnly(date)
        let startDate = new Date(myState.startDate);
        if (myState.startDate === undefined || myState.startDate === null) {
          startDate = endDate
        } else {
          startDate = new Date(myState.startDate);
        }
        if (startDate > new Date(endDate)) {
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "Start date should not be greater than end date",
          });
        }
        else {
          endDate = new Date(endDate).toISOString().split('T')[0];
          startDate = new Date(startDate).toISOString().split('T')[0];
          setState((prevData) => ({ ...prevData, [name]: endDate, startDate: startDate }));
        }
      }
    } else {
      let startDate = new Date(date);
      startDate = getDateOnly(new Date(startDate))
      setState((prevData) => ({ ...prevData, 'startDate': startDate, endDate: null }));
    }

  }
  const handleDate = (date, name) => {
    //  let newvalue = convert(date);
    if (date == null) {
      setState((prevData) => ({ ...prevData, [name]: null }));
      return;

    }
    const request_type = myState['employeDetails']["employee_bookable_status"] && myState.employeDetails.employee_bookable_status === "Y" ? "BS-UBK" : "BS-BK"
    dateValidation(date, name, request_type)
  }

  const resetError = (name) => {
    if (name == "chassisNo") {
      strflag();
    }



  }
  const mappingTable = () => (
    <div
      className={styles.formGroup}>
      {activeId &&
        <Grid
          container
          spacing={1}
          style={{ marginTop: "10px" }}
          // className={styles.myGrid}
          columns={12}
        >
          <Grid item md={8} lg={8} xs={8} />
          <Grid item md={4} lg={4} xs={4}>
            <div className={styles.requestid}>
              <div className={clsx(styles.lableDiv2)}>
                <label style={{ textAlign: "right" }}>Request ID: {activeId}</label>
              </div>
            </div>
          </Grid>
        </Grid>}
      <Grid
        container
        spacing={1}
        // className={styles.myGrid}
        style={{ marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={2} lg={2} xs={2} sm={2}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv2)}>
              <label>Employee Details</label>
            </div>
          </div>
        </Grid>
        {loading == true ?
          <div style={{ textAlign: "center", display: "flex", justifyContent: "center", marginTop: "10px", background: "white", boxShadow: "0px 3px 6px #00000027" }}>
            <Truckloading />
          </div>
          : (
            <Grid item md={10} lg={10} xs={10} sm={10}>
              <TableSimple
                tableColumnData={[
                  {
                    ticket: (activeId ? <div>{myState.ticket_number}</div> :
                      <ValidatingTextField
                        variant="outlined"
                        size="small"
                        isDisabled={activeId || disableTicketNumber}
                        value={myState.ticket_number || ticketEvent?.target?.value}
                        onChange={(e) => {
                          onChangeHandler
                          setState((prevState) => {
                            return {
                              ...prevState,
                              ticket_number: e.target.value
                            };
                          });
                          setTicketEvent(e)
                        }}
                        name="ticket_number"
                        inputProps={{
                          "data-testid": "remark-input",
                        }}
                        style={{ width: "100%" }}
                      />
                    ),
                    empName: myState.employeDetails["employee_name"] ?? "",
                    bcNo: myState.employeDetails["bc_no"] ?? "",
                    bcDesc: myState.employeDetails["costcenter_name"] ?? "",
                    workArea: myState.employeDetails["workarea"] ?? "",
                  },
                ]}
                tableHeaderLabel={[
                  "Ticket No_100",
                  "Employee Name",
                  "BC Number",
                  "BC Name",
                  "Work Area",
                ]}
                TableRowHederAling="start"
                size="small"
                headerColor="#E6F2FF"
                className="custom-table"
              />
            </Grid>
          )}
      </Grid>
    </div>
  )
  const ApproverTable = () => (
    <div
      className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        // className={styles.myGrid}
        // style={{ marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={2} lg={2} xs={2}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv2)}>
              <label>Approval Details :</label>
            </div>
          </div>
        </Grid>
        <Grid item md={10} lg={10} xs={10}>
          <TableSimple
            tableColumnData={[
              {
                ticket: myState.employeDetails["bc_pers_no"],
                empName: myState.employeDetails["bc_head_name"] ?? "",
                bcNo: myState.employeDetails["bc_head_costcenter"] ?? "",
                bcDesc: myState.employeDetails["bc_head_costcenter_name"] ?? "",
                workArea: myState.employeDetails["bc_head_workarea"] ?? "",
              },
            ]}
            tableHeaderLabel={[
              "Ticket Number_80",
              "Employee Name",
              "BC Number",
              "BC Name",
              "Work Area",
            ]}
            TableRowHederAling="start"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
          />
        </Grid>
      </Grid>
    </div>
  )
  const empDetails = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      >
        <Grid item md={12} lg={12} xs={12}>
          <TableSimple
            tableColumnData={employeeDetails}
            tableHeaderLabel={[
              "Ticket Number_80",
              "Employee Name",
              "BC Number",
              "BC Name",
              "Work Area",
            ]}
            TableRowHederAling="start"
            size="small"
            headerColor="#2C73D2"
            className="custom-table"
          />
        </Grid>
      </Grid>
    </div>
  );
  const getEmployeeDetails = async(ticket_number) => {
    setLoading(true)
    let apiFormatedData =
    {
      "ticket_no": ticket_number,
      "flag": "BS",
      "user_role": userRole
    }
    // console.log(apiFormatedData);
    var apiFormatedDataJson = JSON.stringify(apiFormatedData);
    let headerss = new Headers();
    headerss.append('Content-Type', 'application/json');
    try {
      const response = await apiService.getEmployeeDetails(apiFormatedData, dispatchNew)
      dispatchNew(setLogin({ ...auth, recentStatus: response.status }))
      if (response?.length) {
        setLoading(false)
        if (response?.length > 0) {
          // setState((prevData) => ({ ...prevData, employeDetails: responseJson[0]}));
          if (response[0].bc_pers_no == null || response[0].bc_head_name == null) {
            const containsSA = auth.userRole.includes("SA");
            if (!containsSA) {
              showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: 'No Approving Authority request you to contact SBP team',
                reload: true,
              });
              setDisableButtton(true)
            }
            setState((prevData) => ({ ...prevData, employeDetails: response[0], endDate: null }));
            const request_type = response[0]["employee_bookable_status"] && response[0].employee_bookable_status === "Y" ? "BS-UBK" : "BS-BK"
            dateValidation(moment().toDate(), 'startDate', request_type, 'api')
            // handleDate(moment().toDate(),'startDate') 

          }
          else {
            setState((prevData) => ({ ...prevData, employeDetails: response[0], endDate: null }));
            const request_type = response[0]["employee_bookable_status"] && response[0].employee_bookable_status === "Y" ? "BS-UBK" : "BS-BK"
            dateValidation(moment().toDate(), 'startDate', request_type, 'api')

            // handleDate(moment().toDate(),'startDate') 
            setDisableButtton(false)

          }
        }
        else if (response["error"]) {
          setState((prevData) => ({ ...prevData, employeDetails: response }));
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: response["error"],
            reload: true,
          });

        }
        if (response.msg === "Success") {
          setLoading(false)
          // setProjectLinkageStatusCountData(res.data)
        }
        else if (response.msg === "Fail") {
          setLoading(false)
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: response.data,
            reload: true,
          });
        }
      }
    } catch (error) {
      setLoading(false)
    }
  }
  const onChangeHandler = (event) => {
    const { name, value } = event.target;
    // console.log("name, value", name, value, value.length)
    const numericValue = value.replace(/\D/g, '');
    // console.log("name, value", name, numericValue, numericValue.length);
    // setState((prevData) => ({...prevData, [name]: value }));
    setState((prevData) => ({ ...prevData, [name]: numericValue }));

    // if (name === "ticket_number" && event.target.value.length === 6)
    if (name === "ticket_number" && numericValue) {
      getEmployeeDetails(numericValue)
    } else {
      setState((prevData) => ({ ...prevData, employeDetails: [] }));
    }
    resetError(name);
    // setEDetails(event.target.value.length)
    setEDetails(numericValue.length);

  }

  useEffect(() => {
    setEDetails('')
    if (searchByTicket?.target?.value) {
      getEmployeeDetails(searchByTicket?.target?.value);
      setEDetails(searchByTicket?.target?.value?.length)
    }
  }, [searchByTicket?.target?.value])
  
  
  const strflag = () => {
    var regexp = new RegExp(/^[a-zA-Z0-9 ]+$/);
    let str = myState.chassisNo;
    if (myState.chassisNo == "") {
      return
    }

    if (regexp.test(str)) {


      setState((prevData) => ({ ...prevData, chassisNoFlagStr: false }))
      return true
    }
    else {
      setState((prevData) => ({ ...prevData, chassisNoFlagStr: true }))
      return false

    }

  }
 
  const BG_COLOR = '#fffef8';
  const [backgroundColors, setBackgroundColors] = useState({
    processInfoBg: true,
    supplierInfoBg: false,
    poInfoBg: false,
    projectsInfoBg: false
  });
  const { processInfoBg, supplierInfoBg, poInfoBg, projectsInfoBg } = backgroundColors;

  const changeBackgroundColor = (field) =>
    setBackgroundColors(prev => {
      const newBackgroundColors = {};
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(prev)) {
        if (key === field)
          newBackgroundColors[key] = true;
        else
          newBackgroundColors[key] = false;
      }
      return newBackgroundColors
    })


  const loadSupliers = async () => loadData(getSuppliers, API_RESOURCE_URLS.getSuppliers(),
    { plantCode: plant ? plant.value : null, partNumber: part ? part.value : null });
  const handleOpen = () => setIsPopupOpen(true);
  const handleClose = () => setIsPopupOpen(false);
  const handleOpen1 = () => {
    setConfirmModal(true);


  };
  const handleOpen2 = () => {
    setConfirmModal2(true);


  };
  const handleClose2 = () => setConfirmModal2(false);
  const resetFields = () => {
    if (myState.checkFlag == true) {
      setState((prevData) => ({
        ...prevData,
        chassisNo: null,
        toDate: null,
        fromDate: null,
      }));
    } else {
      setState((prevData) => ({
        ...prevData,
        chassisNo: null,
        toDate: null,
        fromDate: null,
        bodyBuilder: null,
      }));
    }

    setTableData([])
    setHighlightMandatoryFields(false)

  }

  const processProjectList = projectList => {
    let processedProjectList = projectList.map(({ ...project }) => {
      const allPlants = project.plants.map(item => item.name);
      const allVehicleLines = project.vehicleLines;
      const projectCreationDate = moment(project.createdAt).format("DD/MM/YYYY");
      return {
        id: project.id,
        ...project,
        allPlants,
        allVehicleLines,
        projectCreationDate
      }
    });
    const allPlantsList = [];
    const allVehicleLineList = [];
    processedProjectList.forEach(({ allPlants, vehicleLines }) => {
      allPlantsList.push(...allPlants);
      allVehicleLineList.push(...vehicleLines);
    });

    processedProjectList = processedProjectList.map(({ ...project }) => (
      {
        ...project,
        allPlants: [...new Set(allPlantsList)],
        allVehicleLines: [...new Set(allVehicleLineList)],
      }
    ));
    return processedProjectList;
  }
  const loadAllProjects = async () => {
    try {
      setRowsData(prev => ({
        ...prev,
        loading: true,
      }));

      const response = await API.get(
        API_RESOURCE_URLS.PROJECTS
      );

      const { data: projectList } = response;
      const processedProjectList = processProjectList(projectList);

      setRowsData({
        data: processedProjectList,
        filteredData: processedProjectList,
        loading: false,
      });
    } catch (error) {
      showInternalError(error);
      console.error(buildErrorMessage(error));
      setRowsData({
        data: [],
        filteredData: [],
        loading: false,
      });
    }
  };

  const getSupplierDetails = () => {
    if (suppliers && suppliers.data && supplierCode) {
      const findSupplier = suppliers.data.find(x => x.code === supplierCode.value);
      if (findSupplier) {
        dispatch({ type: 'update', field: 'supplierDetails', value: findSupplier });
        dispatch({ type: 'update', field: 'supplierName', value: findSupplier.name });

        const address = { value: findSupplier.address[Object.keys(findSupplier.address).sort().pop()], ...findSupplier.address }
        dispatch({ type: 'update', field: 'supplierLocation', value: Object.values(address).filter(x => x !== '').join(',') });

      }
    }
  }

  const processPoList = poList => {
    const processedPoList = poList.map(({ ...po }) => {
      const plantName = po.plant.name;
      const partDesc = po.part.description;
      const id = po.number;
      const processCreationDate = moment(po.createdAt).format("DD/MM/YYYY");
      return {
        ...po,
        id,
        plantName,
        partDesc,
        processCreationDate
      }
    });
    return processedPoList;
  }

  const loadPO = async () => {
    try {
      setPOData(prev => ({
        ...prev,
        loading: true,
      }));

      const response = await API.get(
        API_RESOURCE_URLS.PURCHASE_ORDER,
        {
          params:
          {
            supplierId: supplierDetails ? supplierDetails.id : null,
            partNumber: part ? part.value : null,
            plantCode: plant ? plant.value : null,
            page: poData.number,
          }
        }
      );
      const processedPoList = processPoList(response.data.content);

      setPOData(prev => ({
        ...prev,
        data: [...prev.data, ...processedPoList],
        filteredData: [...prev.filteredData, ...processedPoList],
        loading: false,
        last: response.data.last
      })
      );

    } catch (error) {
      showInternalError(error);
      console.error(buildErrorMessage(error));
      setPOData({
        number: 0,
        data: [],
        filteredData: [],
        loading: false,
        last: false
      });
    }
  };

  const handleValidation = (event, field) => {
    let err = errors;
    const { value } = event.target;

    switch (field) {
      case 'purchaseBuyerName':
        err['purchaseBuyerName'] = value ? RegExp(Regex.name).test(value) ? '' : 'Name is invalid' : 'Name is required';
        break;

      case 'suppRepresentativeName':
        err['suppRepresentativeName'] = value ? RegExp(Regex.name).test(value) ? '' : 'Name is invalid' : 'Name is required';
        break;

      case 'suppRepresentativeEmail':
        err['suppRepresentativeEmail'] = value ? RegExp(Regex.email).test(value) ? '' : 'Email is invalid' : 'Email is required';
        break;

      case 'suppRepresentativeContact':
        err['suppRepresentativeContact'] = value ? RegExp(Regex.phone).test(value) ? '' : 'Contact is invalid' : 'Contact is required';
        break;

      default:
        break;
    }
    dispatch({ type: 'update', field: 'errors', value: err });
  }


  const renderDetails = () => (

    <div
      className={styles.formGroup}
      // style={{ backgroundColor: processInfoBg ? BG_COLOR : null }}
      onClick={() => changeBackgroundColor('processInfoBg')}
    >

      <Grid
        container
        spacing={1}
        // className={styles.myGrid}
        // style={{marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>Ticket Number</label>
            </div>
            <div className={styles.formDiv}>
              <ValidatingTextField
                variant="outlined"
                size="small"
                value={myState.employeDetails["bc_pers_no"]}
                isDisabled
                // onChange={onChangeHandler}
                name="bc_ticket_number"
                inputProps={{
                  "data-testid": "remark-input",
                }}
                style={{ width: "100%" }}
              />
            </div>
          </div>
          {myState.handoverDateFlag &&
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>Inserted On is mandatory field</div>

          }


        </Grid>
        {eDetails >= 6 &&

          <Grid item md={4} lg={4}>
            <div className={styles.rowDiv}>
              <div className={clsx(styles.lableDiv)}>
                <label> Employee Name</label>
              </div>
              <div className={styles.formDiv}>

                <ValidatingTextField
                  variant="outlined"
                  size="small"
                  value={myState.employeDetails["bc_head_name"]}
                  //       onChange={onChangeHandler}
                  name="bc_head_name"
                  isDisabled
                  inputProps={{
                    "data-testid": "remark-input",
                  }}
                  style={{ width: "100%" }}
                />
              </div>
            </div>
            {myState.handoverDateFlag &&
              // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
              <div style={{ marginLeft: "35px" }} className={styles.error}>Inserted On is mandatory field</div>

            }

          </Grid>}

      </Grid>
      {eDetails >= 6 &&

        <Grid
          container
          spacing={1}
          className={styles.myGrid}
          style={{ marginTop: "10px" }}
          columns={12}
        >
          <Grid item md={4} lg={4}>
            <div className={styles.rowDiv}>
              <div className={clsx(styles.lableDiv)}>
                <label>BC Number</label>
              </div>
              <div className={styles.formDiv}>
                <ValidatingTextField
                  variant="outlined"
                  size="small"
                  value={myState.employeDetails["bc_head_costcenter"]}
                  //       onChange={onChangeHandler}
                  name="bc_head_number"
                  isDisabled
                  inputProps={{
                    "data-testid": "remark-input",
                  }}
                  style={{ width: "100%" }}
                />
              </div>
            </div>
            {myState.handoverDateFlag &&
              // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
              <div style={{ marginLeft: "35px" }} className={styles.error}>Inserted On is mandatory field</div>

            }


          </Grid>

          <Grid item md={4} lg={4}>
            <div className={styles.rowDiv}>
              <div className={clsx(styles.lableDiv)}>
                <label>BC Name </label>
              </div>
              <div className={styles.formDiv}>

                <ValidatingTextField
                  variant="outlined"
                  size="small"
                  value={myState.employeDetails["bc_head_costcenter_name"]}
                  //       onChange={onChangeHandler}
                  name="head_bc_name"
                  isDisabled
                  inputProps={{
                    "data-testid": "remark-input",
                  }}
                  style={{ width: "100%" }}
                />
              </div>
            </div>
            {myState.handoverDateFlag &&
              // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
              <div style={{ marginLeft: "35px" }} className={styles.error}>Inserted On is mandatory field</div>

            }

          </Grid>

        </Grid>}
      {eDetails >= 6 &&

        <Grid
          container
          spacing={1}
          className={styles.myGrid}
          style={{ arginTop: "10px" }}
          columns={12}
        >
          <Grid item md={4} lg={4}>
            <div className={styles.rowDiv}>
              <div className={clsx(styles.lableDiv)}>
                <label>Work Area</label>
              </div>
              <div className={styles.formDiv}>
                <ValidatingTextField
                  variant="outlined"
                  size="small"
                  value={myState.employeDetails["bc_head_workarea"]}
                  //       onChange={onChangeHandler}
                  name="bc_head_workarea"
                  isDisabled
                  inputProps={{
                    "data-testid": "remark-input",
                  }}
                  style={{ width: "100%" }}
                />
              </div>
            </div>
            {myState.handoverDateFlag &&
              // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
              <div style={{ marginLeft: "35px" }} className={styles.error}>Inserted On is mandatory field</div>

            }
          </Grid>
        </Grid>}

    </div>
  );

  const renderSPOCDetails = () => (

    <div className={styles.formGroup}>

      <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{ marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={12} lg={12} xs={12}>
          <TableSimple
            tableColumnData={[
              {

                project_no: "2343",
                project_name: "YODHA CNG",
                ticket_no: "351243",
                spoc_name: "Sandeep Kumar Ghosh",
                status: "Open",

                // Action: (
                //     <div>
                //       <Checkbox value="Yes"  checked={myState.checkBox} onChange={handleCheck} size="small" />
                //     </div>
                //   ),
              },
            ]}
            tableHeaderLabel={[
              "Project No",
              "Project Name",
              "SPOC Ticket No",
              "SPOC Name",
              "Status",

            ]}
            TableRowHederAling="start"
            size="small"
            headerColor="#2C73D2"
            className="custom-table"
          />
        </Grid>
      </Grid>

    </div>



  );

  const renderbookingdetails = () => (
    <div
      className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        // className={styles.myGrid}
        // style={{marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={2} lg={2} xs={12}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv2)}>
              <label>Booking Status Details:</label>
            </div>
          </div>
        </Grid>
        <Grid item md={3} lg={3} xs={12}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv2)}>
              <label>Current Status</label>
            </div>
            <ValidatingTextField
              variant="outlined"
              size="small"
              value={myState.employeDetails["employee_bookable_status"] && myState.employeDetails.employee_bookable_status === "Y" ? "BOOKABLE" : "NON-BOOKABLE"}
              //       onChange={onChangeHandler}
              name="current_booking_status"
              isDisabled
              inputProps={{
                "data-testid": "remark-input",
              }}
              style={{ width: "50%" }}
            />
          </div>
          {myState.handoverDateFlag &&
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>Inserted On is mandatory field</div>

          }


        </Grid>

        <Grid item md={3} lg={3} xs={12}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv2)}>
              <label> Propose Status</label>
            </div>
            {/* <div className={styles.formDiv}> */}

            <ValidatingTextField
              variant="outlined"
              size="small"
              value={myState.employeDetails["proposed_status"]}
              //       onChange={onChangeHandler}
              name="proposed_status"
              isDisabled
              inputProps={{
                "data-testid": "remark-input",
              }}
              style={{ width: "50%" }}
            />
          </div>
          {/* </div> */}
          {myState.handoverDateFlag &&
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>Inserted On is mandatory field</div>

          }
        </Grid>
        <Grid item md={2} lg={2} xs={12}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv2)}>
              <label>From</label>
            </div>

            <CustomDatePicker
              clearable
              // markIfUnselected={highlightMandatoryFields}
              autoOk
              inputVariant="outlined"
              value={myState.startDate || null}
              onChange={(e) => { handleDate(e, 'startDate') }}
              inputProps={{
                className: clsx(styles.select, styles.dateInput),

              }}
              // emptyLabel="dd/mm/yyyy"
              // defaultDate={moment().format(DATE_FORMAT.DD_MM_YYYY)}
              // minDate={!isEditable? null: getMinimumDateForPicker(index, milestones)}
              minDate={moment().startOf('month').toDate()}
              // format="DD/MM/yyyy"
              format="DD-MM-YYYY"
              // format="MM/DD/yyyy"
              data-testid="date-picker-div-1"
              style={{ width: "100%", marginLeft: "24px" }}
            // minDate={moment().toDate()}

            />
          </div>
          {myState.handoverDateFlag &&
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "15px" }} className={styles.error}>Inserted On is mandatory field</div>
          }
        </Grid>
        {/* {myState.employeDetails.employee_bookable_status === "Y" && */}
        <Grid item md={2} lg={2} xs={12}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv2)}>
              <label>To</label>
            </div>

            <CustomDatePicker
              disabled={myState.employeDetails.employee_bookable_status !== "Y"}
              // disabled
              clearable
              // markIfUnselected={highlightMandatoryFields}
              autoOk
              inputVariant="outlined"
              value={myState.employeDetails.employee_bookable_status === "Y" ? myState.endDate : null}
              onChange={(e) => { handleDate(e, 'endDate') }}
              inputProps={{
                className: clsx(styles.select, styles.dateInput),
              }}
              // emptyLabel="dd/mm/yyyy"
              // emptyLabel="mm/dd/yyyy"
              // defaultDate={moment().format(DATE_FORMAT.DD_MM_YYYY)}
              // minDate={!isEditable? null: getMinimumDateForPicker(index, milestones)}
              // format="DD/MM/yyyy"
              format="DD-MM-YYYY"
              data-testid="date-picker-div-1"
              style={{ width: "100%", marginLeft: "24px" }}
              minDate={moment().toDate()}
            />

          </div>
          {myState.handoverDateFlag &&
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>Inserted On is mandatory field</div>

          }

        </Grid>
        {/* } */}

      </Grid>
    </div>


  )
  const renderOther = () => (
    <div
      className={styles.formGroup}
      // style={{ backgroundColor: processInfoBg ? BG_COLOR : null }}
      onClick={() => changeBackgroundColor('processInfoBg')}
    >

      <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{ marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>Ticket Number</label>
            </div>
            <div className={styles.formDiv}>
              <ValidatingTextField
                variant="outlined"
                size="small"
                value={myState.ticket_number}
                onChange={onChangeHandler}
                name="ticket_number"
                inputProps={{
                  "data-testid": "remark-input",
                }}
                style={{ width: "100%" }}
              />
            </div>
          </div>
          {myState.handoverDateFlag &&
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>Inserted On is mandatory field</div>

          }


        </Grid>

        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label> Employee Name</label>
            </div>
            <div className={styles.formDiv}>

              <ValidatingTextField
                variant="outlined"
                size="small"
                value={myState.employeDetails["employee_name"] !== undefined ? myState.employeDetails.employee_name : ""}
                //       onChange={onChangeHandler}
                name="employeeName"
                isDisabled
                inputProps={{
                  "data-testid": "remark-input",
                }}
                style={{ width: "100%" }}
              />
            </div>
          </div>
          {myState.handoverDateFlag &&
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>Inserted On is mandatory field</div>

          }

        </Grid>

      </Grid>

      <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{ marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>BC Number</label>
            </div>
            <div className={styles.formDiv}>
              <ValidatingTextField
                variant="outlined"
                size="small"
                value={myState.employeDetails["bc_no"] !== undefined ? myState.employeDetails.bc_no : ""}
                //       onChange={onChangeHandler}
                name="bc_no"
                isDisabled
                inputProps={{
                  "data-testid": "remark-input",
                }}
                style={{ width: "100%" }}
              />
            </div>
          </div>
          {myState.handoverDateFlag &&
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>Inserted On is mandatory field</div>

          }


        </Grid>

        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>BC Name </label>
            </div>
            <div className={styles.formDiv}>

              <ValidatingTextField
                variant="outlined"
                size="small"
                value={myState.employeDetails["costcenter_name"] !== undefined ? myState.employeDetails.costcenter_name : ""}
                //       onChange={onChangeHandler}
                name="bc_name"
                isDisabled
                inputProps={{
                  "data-testid": "remark-input",
                }}
                style={{ width: "100%" }}
              />
            </div>
          </div>
          {myState.handoverDateFlag &&
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>Inserted On is mandatory field</div>

          }

        </Grid>

      </Grid>

      <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{ marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>Work Area</label>
            </div>
            <div className={styles.formDiv}>
              <ValidatingTextField
                variant="outlined"
                size="small"
                value={myState.employeDetails["workarea"] !== undefined ? myState.employeDetails.workarea : ""}
                //       onChange={onChangeHandler}
                name="work_area"
                isDisabled
                inputProps={{
                  "data-testid": "remark-input",
                }}
                style={{ width: "100%" }}
              />
            </div>
          </div>
          {myState.handoverDateFlag &&
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>Inserted On is mandatory field</div>

          }

        </Grid>
      </Grid>

    </div>
  )

  const handleCancel = () => {
    setState((prevData) => ({ ...prevData, ticket_number: "", employeDetails: [] }));
    setEDetails(0)
    // setEmployeeDetails([]);
    // setTicketNumber("");
    // setState({})
  }

  const renderUserRemark = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        style={{
          marginTop: "10px",
        }}
        // className={styles.myGrid}
        columns={12}
      >
        <Grid item md={2} lg={2} xs={2}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv2)}>
              <label>User Remark :</label>
            </div>
          </div>
        </Grid>
        <Grid item md={10} lg={10} xs={10}>
          <ValidatingTextField
            variant="outlined"
            size="small"
            isDisabled={activeId}
            value={myState.userRemark}
            onChange={(event) => {
              const newValue = event.target.value;
              if (isValidInput(newValue) || newValue === "") {
                setState((prevData) => ({ ...prevData, userRemark: newValue }));
              }
            }}
            name="projectSearch"
            inputProps={{
              "data-testid": "remark-input",
            }}
            style={{ width: "100%" }}
          />
        </Grid>
      </Grid>
      {activeId === undefined &&
        <Grid
          container
          spacing={1}
          // className={styles.myGrid}
          style={{ justifyContent: "center", marginTop: "10px" }}
          columns={12}
        >
          <Grid item md={6} lg={5} />
          <Grid item md={6} lg={7} sm={12}>
            <div className={styles.rowDiv}>
              <div className={styles.formDiv}>
                <Button
                  className={clsx(
                    styles.actionButton,
                    styles.primaryActionButton,
                  )}

                  variant="primary"
                  onClick={() => handleUserRequest()}
                  disabled={disableButtton}
                  data-testid="confirm-action"
                  style={{ marginRight: "5px", display: "flex" }}

                >
                  Save
                </Button>

                <Button
                  className={clsx(styles.actionButton, styles.resetButton)}
                  variant="tertiary"
                  onClick={handleCancel}
                  style={{ marginRight: "5px" }}
                >
                  Cancel
                </Button>

              </div>
            </div>
          </Grid>
        </Grid>}
    </div>
  )

  const renderSPOCRemark = () => (

    <div className={styles.formGroup}>
      {activeId && (userRole.includes("B") || (!userRole.includes("B") && myState.bcApprove === "ACCEPTED")) &&
        <Grid
          container
          spacing={1}
          style={{
            marginTop: "10px",
          }}
          // className={styles.myGrid}
          columns={12}
        >
          <Grid item md={2} lg={2} xs={2}>
            <div className={styles.rowDiv}>
              <div className={clsx(styles.lableDiv2)}>
                <label>BC Head Remark :</label>
              </div>
            </div>
          </Grid>
          <Grid item md={10} lg={10} xs={10}>
            <ValidatingTextField
              variant="outlined"
              size="small"
              isDisabled={!userRole.includes("B") || (userRole.includes("B") && myState.bcApprove !== "INPROGRESS")}
              value={myState.bcHeadRemark}
              onChange={(event) => {
                const newValue = event.target.value;
                if (isValidInput(newValue) || newValue === "") {
                  setState((prevData) => ({ ...prevData, bcHeadRemark: newValue }));
                }
              }}
              name="bcHeadRemark"
              inputProps={{
                "data-testid": "remark-input",
              }}
              style={{ width: "100%" }}
            />
          </Grid>
        </Grid>}
      {userRole.includes("B") && myState.bcApprove === "INPROGRESS" &&
        <Grid
          container
          spacing={1}
          // className={styles.myGrid}
          style={{
            marginTop: "10px"
          }}
          columns={12}
        >
          <Grid item md={6} lg={5} />
          <Grid item md={6} lg={7}>
            <div className={styles.rowDiv}>

              <div className={styles.formDiv}>
                <Button
                  className={clsx(
                    styles.actionButton,
                    styles.primaryActionButton,
                  )}
                  variant="primary"
                  onClick={() => handleApproveReject("BCHead", "A")}
                  //     disabled={(myState.chassisNo == null)}
                  data-testid="confirm-action"
                  style={{ marginRight: "5px" }}

                >
                  Approve
                </Button>

                <Button
                  className={clsx(styles.actionButton, styles.resetButton)}
                  variant="tertiary"
                  onClick={() => handleApproveReject("BCHead", "R")}
                  style={{ marginRight: "5px" }}
                >
                  Reject
                </Button>

              </div>
            </div>
          </Grid>
        </Grid>
      }
    </div>
  )

  const renderSuperAdminRemark = () => (
    <div className={styles.formGroup}>
      {/* {(userRole !== 'SA' && (myState.employeDetails["admin_approval_status"] === "ACCEPTED"|| myState.employeDetails["admin_approval_status"] === "REJECTED")) || userRole === 'SA' &&  */}
      {activeId && (userRole.includes("SA") || (!userRole.includes("SA") && myState.saApprove === "ACCEPTED")) &&
        <Grid
          container
          spacing={1}
          style={{
            marginTop: "10px",
          }}
          // className={styles.myGrid}
          columns={12}
        >

          {!userRole.includes("SA") && (myState.saApprove !== "ACCEPTED" || myState.saApprove !== "REJECTED") || (userRole.includes("SA") && myState.saApprove !== "INPROGRESS") ? ""
            : <>
              <Grid item md={2} lg={2} xs={2}>
                <div className={styles.rowDiv}>
                  <div className={clsx(styles.lableDiv2)}>
                    <label>Super Admin Remark :</label>
                  </div>
                </div>
              </Grid>
              <Grid md={10} lg={10} xs={10}>
                <ValidatingTextField
                  variant="outlined"
                  size="small"
                  isDisabled={(!userRole.includes("SA") && (myState.saApprove !== "ACCEPTED" || myState.saApprove !== "REJECTED")) || (userRole.includes("SA") && myState.saApprove !== "INPROGRESS")}
                  value={myState.superAdminRemark}
                  onChange={(event) => {
                    const newValue = event.target.value;
                    if (isValidInput(newValue) || newValue === "") {
                      setState((prevData) => ({ ...prevData, superAdminRemark: newValue }));
                    }
                  }}
                  name="projectSearch"
                  inputProps={{
                    "data-testid": "remark-input",
                  }}
                  style={{ width: "100%", }}
                />
              </Grid>
            </>


          }

        </Grid>
      }
      {userRole.includes("SA") && myState.saApprove === "INPROGRESS" &&
        <Grid
          container
          spacing={1}
          // className={styles.myGrid}
          style={{
            marginTop: "10px"
          }}
          columns={12}
        >
          <Grid item md={6} lg={5} />
          <Grid item md={6} lg={7}>
            <div className={styles.rowDiv}>

              <div className={styles.formDiv}>
                <Button
                  className={clsx(
                    styles.actionButton,
                    styles.primaryActionButton,
                  )}
                  variant="primary"
                  onClick={() => handleApproveReject("SuperAdmin", "A")}
                  //     disabled={(myState.chassisNo == null)}
                  data-testid="confirm-action"
                  style={{ marginRight: "5px" }}
                >Approve</Button>
                <Button
                  className={clsx(styles.actionButton, styles.resetButton)}
                  variant="tertiary"
                  onClick={() => handleApproveReject("SuperAdmin", "R")}
                  style={{ marginRight: "5px" }}
                >Reject</Button>
              </div>
            </div>
          </Grid>
        </Grid>
      }
    </div>
  )



  const getSelectedFields = () => ({
    projectId: selectedProject,
    poNumber: selectedPO,
    commodityGroupId: purchaseCommodity && purchaseCommodity.value,
    aqCommodityGroupId: aqCommodity && aqCommodity.value,
    purchaseBuyerName: inputFields?.purchaseBuyerName,
    kamContactDetails: {
      // id: inputFields,
      name: inputFields?.suppRepresentativeName,
      contactNumber: inputFields?.suppRepresentativeContact,
      emailId: inputFields?.suppRepresentativeEmail
    }
  });

  const validateFields = (fields) => {
    const requiredFields = { ...fields, ...fields.kamContactDetails }
    const hasMissingRequiredFields = Object.values(requiredFields).some(
      (field) => !field
    );

    const hasError = Object.values(errors).some((err) => err);

    if (hasMissingRequiredFields || hasError) {
      return false;
    }
    return true;
  };

  const runPreSubmissionChecks = () => {
    const selectedFields = getSelectedFields();
    const areFieldsValid = validateFields(selectedFields);

    if (!areFieldsValid) {
      setHighlightMandatoryFields(true);
      // return false;
      return true;
    }
    return true;
  };







  const resetAllInputs = () => {
    const inputs = {
      purchaseBuyerName: '',
      suppRepresentativeName: '',
      suppRepresentativeContact: '',
      suppRepresentativeEmail: ''
    }
    dispatch({ type: 'update', field: 'inputFields', value: inputs });
    dispatch({ type: 'update', field: 'errors', value: {} });
  }

  const resetState = () => {
    dispatch({ type: 'reset' });
    resetAllInputs();
    resetTableData();
    setHighlightMandatoryFields(null);
    setResetAllVisitedFields(false);
    changeBackgroundColor('processInfoBg');
  }



  useEffect(() => {
    if (resetAllVisitedFields)
      resetState();
  }, [resetAllVisitedFields])

  // console.log(myState)

  const RedirectToDashboard = () => {
    const reqtype = requestType.split("-").shift();
    if (reqtype == "PL") {
      dispatchNew(setLogin({ ...auth, apiSendData: apiPayloadData }));
      history.push("/linkage-dashboard");
    }
    else if (reqtype == "BS" || reqtype == "AA") {
      dispatchNew(setLogin({ ...auth, apiSendData: apiPayloadData }));
      history.push("/requestor-dashboard")
    }
  }

  const gridFlag = activeId ? 11 : 12;

  return (
    <>
      <div className={clsx(styles.scrollContainer, styles.scrollBar, styles.formContainer)}>

        <Grid container spacing={0}>
          {activeId ? <Grid item md={1} lg={1} xs={1} sm={1} style={{ marginRight: '-30px' }}>
            {/* <MuiButton 
                variant="contained" 
                color="success" 
                style={{
                  backgroundColor: '#59a385', 
                  color: 'white',
                  padding: '5px 15px 3px 15px', 
                  borderRadius: '0px' }} 
                startIcon={<ArrowCircleLeftIcon/>} 
                onClick={() => RedirectToDashboard()}
              > 
              Back 
              </MuiButton> */}
            <ArrowCircleLeftIcon
              style={{
                fontSize: '40px',
                color: "#608FC9",
                margin: '-3px 0px 1px 10px',
                cursor: 'pointer'
              }}
              onClick={() => RedirectToDashboard()}
            />
          </Grid>
            : ""}
          <Grid item md={gridFlag} lg={gridFlag} xs={gridFlag} sm={gridFlag}>
            <CustomFormGroup
              header="Change Booking Status"
            // body={mappingTable()}
            />
          </Grid>
        </Grid>

        {mappingTable()}

        <>
          {(eDetails === 6 || eDetails === 8) && !("error" in myState.employeDetails) && (
            <>
              {renderbookingdetails()}
              {ApproverTable()}
            </>
          )}
        </>

        {/* <CustomFormGroup header='Approval Details' 
       body={
        // renderDetails()
        ApproverTable()
      } />
       } */}
        {/* <CustomFormGroup header='Linkage SPOC Details' body={renderSPOCDetails()} /> */}
        {
          (eDetails === 6 || eDetails === 8) && !("error" in myState.employeDetails) && renderUserRemark()
        }
        {
          (eDetails === 6 || eDetails === 8) && activeId && renderSPOCRemark()
        }
        {
          (eDetails === 6 || eDetails === 8) && activeId && renderSuperAdminRemark()
        }

        {/* { eDetails >= 6 && userRole === "BC_Head" &&
        <CustomFormGroup header='BC Head Remark (Optional)' body={renderSPOCRemark()} />
        }
        { eDetails >= 6 && userRole === "Super_Admin" &&
        <CustomFormGroup header='SBP Remark' body={renderSuperAdminRemark()} />
        } */}




      </div>


      <ResetModal
        isPopupOpen={isPopupOpen}
        handleClose={handleClose}
        resetFields={resetFields}
      />

      <ResetModal2
        a={confirmModalFlag2}
        handleCase={handleClose2}
        onDelete={() => onDeleteRow2(deleteParam2)}
      />


    </>
  )
}


function ResetModal2({ a, handleCase, onDelete }) {
  return (
    <Dialog
      open={a}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup1"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <DeleteIcon style={{ height: '18px', width: '18px' }} />
            <span className={styles.txt}>Are you sure ?</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>
            Do you want to delete ?
          </span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(
              styles.actionButton,
              styles.transparentButton
            )}
            onClick={handleCase}
          >Cancel</Button>
          <Button
            className={clsx(
              styles.actionButton,
              styles.primaryActionButton,
            )}
            variant="primary"
            onClick={onDelete}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  )
}
function ResetModal1({ a, handleCase, onDelete }) {
  return (
    <Dialog
      open={a}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup1"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <DeleteIcon style={{ height: '18px', width: '18px' }} />
            <span className={styles.txt}>Are you sure ?</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>
            Do you want to delete ?
          </span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(
              styles.actionButton,
              styles.transparentButton
            )}
            onClick={handleCase}
          >Cancel</Button>
          <Button
            className={clsx(
              styles.actionButton,
              styles.primaryActionButton,
            )}
            variant="primary"
            onClick={onDelete}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  )
}

function ResetModal({ isPopupOpen, handleClose, resetFields }) {
  return (
    <Dialog
      open={isPopupOpen}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <MdReplay style={{ height: '18px', width: '18px' }} />
            <span className={styles.txt}>Reset</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>
            Are you sure you want to reset the filters?
          </span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(
              styles.actionButton,
              styles.transparentButton
            )}
            onClick={handleClose}
          >Cancel</Button>
          <Button
            className={clsx(
              styles.actionButton,
              styles.primaryActionButton,
            )}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              handleClose()
              resetFields()
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  )
}

AccessControlForm.propTypes = {
  redirectToProcessPage: PropTypes.func
}

ResetModal.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  resetFields: PropTypes.func.isRequired
}
ResetModal1.propTypes = {
  a: PropTypes.bool.isRequired,
  handleCase: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
}
ResetModal2.propTypes = {
  a: PropTypes.bool.isRequired,
  handleCase: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth
});
const mapDispatchToProps = (dispatch) => ({

  fetchChassis: (chassisParam) => dispatch(fetchChassis(chassisParam)),
  getInvoice: (chassisParam) => dispatch(getInvoice(chassisParam)),
});
AccessControlForm.propTypes = {
  counter: PropTypes.number,
  baseUrl: PropTypes.string,
  product: PropTypes.object,
  auth: PropTypes.object,
};
const App = connect(mapStateToProps, mapDispatchToProps)(AccessControlForm);


export default withAllowedOperationsProvider(
  App,
  RESOURCE_TYPE.PPAP
);
